import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from '../../data/seo';

/**
 * Keeps document metadata in sync with the current route.
 *
 * This app is a client-rendered SPA, so the static tags in public/index.html
 * are the homepage-level defaults that social scrapers and non-JS crawlers
 * read. On navigation we update those SAME tags in place (find-or-create by
 * selector) rather than appending new ones, so there are never duplicate
 * <title>/description tags and JS-executing crawlers (Googlebot) see the
 * correct per-page values.
 */
function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = resolveSeo(pathname);

    document.title = seo.title;
    upsertMeta('name', 'description', seo.description);
    upsertLink('canonical', seo.canonical);

    upsertMeta('property', 'og:title', seo.title);
    upsertMeta('property', 'og:description', seo.description);
    upsertMeta('property', 'og:url', seo.canonical);

    upsertMeta('name', 'twitter:title', seo.title);
    upsertMeta('name', 'twitter:description', seo.description);

    upsertMeta('name', 'robots', seo.noindex ? 'noindex, follow' : 'index, follow');
  }, [pathname]);

  return null;
}
